(() => {
  if (window.LuceInspirationInit) return;
  window.LuceInspirationInit = true;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const reveals = document.querySelectorAll('[data-i-reveal]');
  if (!reduced && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: .13 });
    reveals.forEach((item) => observer.observe(item));
  } else {
    reveals.forEach((item) => item.classList.add('is-visible'));
  }

  document.querySelectorAll('[data-i-tabs]').forEach((tabs) => {
    const buttons = tabs.querySelectorAll('[data-i-tab]');
    const panels = tabs.parentElement.querySelectorAll('[data-i-panel]');
    buttons.forEach((button) => button.addEventListener('click', () => {
      buttons.forEach((item) => item.classList.toggle('is-active', item === button));
      panels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.iPanel === button.dataset.iTab));
    }));
  });

  if (!reduced) {
    const heroes = document.querySelectorAll('[data-i-parallax]');
    let ticking = false;
    const update = () => {
      heroes.forEach((hero) => {
        const rect = hero.getBoundingClientRect();
        hero.style.setProperty('--i-parallax', `${Math.max(-40, Math.min(40, -rect.top * .06))}px`);
      });
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }
})();
